import React, { Component } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { API_URL } from "../Constants"; // Import API_URL
import TeamMember from '../TileIcon/TeamMember';

class DivisionTab extends Component {
    constructor() {
        super();
        this.state = {
            data: []
        }
    }

    componentDidMount() {
        fetch(`${API_URL}/app/api/v1/divisions?filter=status==A`)
            .then(results => {
                return results.json();
            }).then(resp => {
                this.setState({ data: resp });
            });
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="header">
                            <h4 className="title">Divisions &amp; Teams</h4>
                        </div>

                        <div>
                            <Tabs id="tab-with-icons">
                                {this.state.data.map(item => (
                                    <Tab eventKey={item.id} title={<span><i className="fa fa-info"></i> {item.name}</span>}>
                                        <TeamMember divisionId={item.id} />
                                    </Tab>
                                ))}
                            </Tabs>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
export default DivisionTab;


// WEBPACK FOOTER //
// ./src/components/Panels/DivisionsTab.js